import React, { useState } from "react";
import BookingForm from "./BookingForm";
import SummaryPage from "./SummaryPage";
import PaymentPage from "./PaymentPage";
import { useLocation, useParams } from "react-router-dom";
import SEO from "../../SEO";

const SpecialPackageFlow = () => {
  const location = useLocation();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const { packageId } = useParams();
  const pkg = location.state;

  return (
    <>
      <SEO
        title={`${pkg.packageName} – Special Package | Trust Doc`}
        description={pkg.shortDescription}
        canonical={`https://www.trust-doc.com/special-packages/${packageId}`}
        image={pkg.image}
      />
      {step === 1 && (
        <BookingForm
          formData={formData}
          setFormData={setFormData}
          onNext={() => setStep(2)}
          packageId={packageId}
          pkg={pkg}
        />
      )}
      {step === 2 && (
        <SummaryPage
          formData={formData}
          onBack={() => setStep(1)}
          onNext={() => setStep(3)}
        />
      )}
      {step === 3 && (
        <PaymentPage formData={formData} onBack={() => setStep(2)} />
      )}
    </>
  );
};

export default SpecialPackageFlow;
